export const CommonExtensionNames: Record<string, string> = {
  '.7z': '7-Zip Archive File',
  '.accdb': 'Microsoft Access Database',
  '.ace': 'WinAce Compressed File',
  '.ade': 'Access Project Extension',
  '.adp': 'Access Project File',
  '.ai': 'Adobe Illustrator Artwork',
  '.aif': 'Audio Interchange File Format',
  '.aiff': 'Audio Interchange File Format',
  '.ani': 'Animated Cursor File',
  '.apk': 'Android Package File',
  '.appx': 'Windows App Package',
  '.asf': 'Advanced Systems Format (Windows Media)',
  '.asp': 'Active Server Page',
  '.aspx': 'ASP.NET Server Page',
  '.au': 'Audio File (AU format)',
  '.avi': 'Audio Video Interleave',
  '.bak': 'Backup File',
  '.bas': 'BASIC Source Code File',
  '.bat': 'Batch File (script)',
  '.bin': 'Binary File',
  '.bkf': 'Windows Backup File',
  '.bmp': 'Bitmap Image File',
  '.bpl': 'Borland Package Library',
  '.bz2': 'Bzip2 Compressed File',
  '.cab': 'Windows Cabinet File',
  '.cat': 'Security Catalog File',
  '.cda': 'CD Audio Track Shortcut',
  '.cfg': 'Configuration File',
  '.chm': 'Compiled HTML Help File',
  '.class': 'Java Class File',
  '.cmd': 'Windows Command Script',
  '.com': 'Command File (DOS/Windows executable)',
  '.cpl': 'Control Panel Extension',
  '.cpp': 'C++ Source Code File',
  '.crt': 'Security Certificate File',
  '.cs': 'C# Source Code File',
  '.css': 'Cascading Style Sheets',
  '.csv': 'Comma-Separated Values File',
  '.cur': 'Windows Cursor File',
  '.dat': 'Generic Data File',
  '.db': 'Database File',
  '.dbf': 'dBASE Database File',
  '.dcr': 'Shockwave Media File',
  '.der': 'DER Encoded Certificate',
  '.dib': 'Device Independent Bitmap',
  '.dif': 'Data Interchange Format',
  '.dll': 'Dynamic-Link Library',
  '.dmg': 'Apple Disk Image',
  '.dmp': 'Windows Memory Dump File',
  '.doc': 'Microsoft Word Document (legacy)',
  '.docm': 'Word Macro-Enabled Document',
  '.docx': 'Microsoft Word Document (XML-based)',
  '.dot': 'Word Template Document',
  '.drv': 'Device Driver File',
  '.eml': 'Email Message File',
  '.eps': 'Encapsulated PostScript File',
  '.exe': 'Executable File',
  '.fla': 'Adobe Animate Source File',
  '.flac': 'Free Lossless Audio Codec',
  '.flv': 'Flash Video File',
  '.fnt': 'Font File',
  '.fon': 'Generic Font File',
  '.gif': 'Graphics Interchange Format',
  '.gz': 'Gzip Archive File',
  '.h': 'C/C++ Header File',
  '.hlp': 'Windows Help File',
  '.htm': 'HyperText Markup Language File',
  '.html': 'HyperText Markup Language File',
  '.ico': 'Icon File',
  '.ics': 'iCalendar File',
  '.idx': 'Index File',
  '.ifo': 'DVD Information File',
  '.img': 'Disk Image File',
  '.inf': 'Setup Information File',
  '.ini': 'Initialization File',
  '.iso': 'ISO Disc Image File',
  '.jar': 'Java Archive File',
  '.java': 'Java Source Code File',
  '.jpe': 'JPEG Image File',
  '.jpeg': 'JPEG Image File',
  '.jpg': 'JPEG Image File',
  '.js': 'JavaScript File',
  '.json': 'JavaScript Object Notation Data',
  '.key': 'License Key / Keynote File',
  '.lnk': 'Windows Shortcut File',
  '.log': 'Log File',
  '.m3u': 'MP3 Playlist File',
  '.m4a': 'MPEG-4 Audio File',
  '.m4v': 'MPEG-4 Video File',
  '.man': 'Manual Page File',
  '.max': '3ds Max Scene File',
  '.mdb': 'Microsoft Access Database File',
  '.mdf': 'SQL Server Database File',
  '.mid': 'Musical Instrument Digital Interface File',
  '.midi': 'Musical Instrument Digital Interface File',
  '.mkv': 'Matroska Video File',
  '.mov': 'Apple QuickTime Movie File',
  '.mp3': 'MPEG Layer 3 Audio File',
  '.mp4': 'MPEG-4 Video File',
  '.mpa': 'MPEG Audio File',
  '.mpeg': 'MPEG Video File',
  '.mpg': 'MPEG Video File',
  '.msi': 'Windows Installer Package',
  '.msu': 'Windows Update Package File',
  '.nls': 'National Language Support File',
  '.nsf': 'Lotus Notes Database File',
  '.obj': 'Object File (compiled code)',
  '.ocx': 'ActiveX Control File',
  '.odt': 'OpenDocument Text Document',
  '.ogg': 'Ogg Vorbis Audio File',
  '.part': 'Partially Downloaded File',
  '.pdb': 'Program Database File',
  '.pdf': 'Portable Document Format File',
  '.php': 'PHP Script File',
  '.pkg': 'Package File',
  '.pl': 'Perl Script File',
  '.png': 'Portable Network Graphics File',
  '.pif': 'Program Information File (legacy DOS)',
  '.pps': 'PowerPoint Slide Show (legacy)',
  '.ppsx': 'PowerPoint Slide Show (XML-based)',
  '.ppt': 'PowerPoint Presentation (legacy)',
  '.pptx': 'PowerPoint Presentation (XML-based)',
  '.ps': 'PostScript File',
  '.ps1': 'PowerShell Script File',
  '.psd': 'Adobe Photoshop Document',
  '.pst': 'Outlook Personal Storage File',
  '.pub': 'Microsoft Publisher Document',
  '.py': 'Python Script File',
  '.qbb': 'QuickBooks Backup File',
  '.qbw': 'QuickBooks Data File',
  '.rar': 'RAR Compressed Archive File',
  '.reg': 'Windows Registry File',
  '.resx': '.NET Resource XML File',
  '.rm': 'RealMedia File',
  '.rtf': 'Rich Text Format File',
  '.sav': 'Saved Game File',
  '.sdf': 'SQL Server Database File',
  '.sh': 'Shell Script File',
  '.shtml': 'Server-Side Include HTML File',
  '.sit': 'StuffIt Archive File',
  '.sln': 'Visual Studio Solution File',
  '.sql': 'Structured Query Language Data File',
  '.sqlite': 'SQLite Database File',
  '.svg': 'Scalable Vector Graphics File',
  '.swf': 'Shockwave Flash File',
  '.sys': 'Windows System File',
  '.tar': 'Tape Archive File',
  '.tgz': 'Gzipped Tar Archive',
  '.tif': 'Tagged Image File Format',
  '.tiff': 'Tagged Image File Format',
  '.tmp': 'Temporary File',
  '.torrent': 'BitTorrent File',
  '.ttf': 'TrueType Font File',
  '.txt': 'Plain Text File',
  '.url': 'Internet Shortcut File',
  '.vbs': 'VBScript File',
  '.vcf': 'vCard Contact File',
  '.vcd': 'Virtual CD Image File',
  '.vdi': 'VirtualBox Disk Image',
  '.vhd': 'Virtual Hard Disk File',
  '.vhdx': 'Hyper-V Virtual Hard Disk File',
  '.vob': 'DVD Video Object File',
  '.vsd': 'Microsoft Visio Document File',
  '.vsdx': 'Microsoft Visio Document File',
  '.wav': 'Waveform Audio File',
  '.wbk': 'Word Document Backup File',
  '.webm': 'WebM Video File',
  '.wma': 'Windows Media Audio File',
  '.wmv': 'Windows Media Video File',
  '.wpl': 'Windows Media Player Playlist File',
  '.xhtml': 'Extensible Hypertext Markup Language File',
  '.xla': 'Excel Add-In File',
  '.xls': 'Excel Spreadsheet (legacy)',
  '.xlsm': 'Excel Macro-Enabled Spreadsheet',
  '.xlsx': 'Excel Spreadsheet (XML-based)',
  '.xml': 'Extensible Markup Language File',
  '.xps': 'XML Paper Specification Document',
  '.yaml': 'YAML Configuration File',
  '.yml': 'YAML Configuration File',
  '.z': 'Unix Compressed File',
  '.zip': 'ZIP Archive File',
  '.zoo': 'Zoo Compressed Archive File',
};

export function normalizeExtension(input: string | null | undefined): string {
  if (!input) return '';
  let ext = String(input).trim();
  if (!ext) return '';
  if (!ext.startsWith('.')) ext = `.${ext}`;
  return ext.toLowerCase();
}

export function getFriendlyNameForExtension(ext: string | null | undefined): string {
  const key = normalizeExtension(ext || '');
  if (!key) return '';
  return CommonExtensionNames[key] || '';
}
